/**
 * A compile and runtime check that a code branch is not reachable.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const assertUnreachable = (_: never): never => {
  throw new Error("This code branch has not been covered exhaustively");
};
